/**
 * Check if the device supports hover events.
 */
export const supportsHover = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia('(hover: hover)').matches;
};
